export class DashboardMapConstants {
  /* The dashboard map has no paging control, so a single page must cover every pin.
     Relies on the raised MaxPageSize on the SearchProjects resolver. */
  public static readonly MAXIMUM_PINS = 200;

  public static readonly HEIGHT = 623;

  public static readonly EXPANDED_HEIGHT = "max(623px, 70vh)";
}
